import { Plugins } from "./system/Plugins.js";
import { PostEdit } from "./system/PostEdit.js";
import { AjaxClick } from "./utils/AjaxClick.js";

export class Frontend {

    constructor() {

        console.log("[eventfive.wordpress-plugin]", "[Frontend]");

        new Plugins();

        if (e5.Plugins.config?.editPostLink) {
            e5.Debug.add({
                uid: "edit-current-post",
                icon: "fab fa-wordpress-simple",
                tooltip: "Edit Post",
                url: e5.Plugins.config.editPostLink
            });
        }

        //TODO: add it to eventfive settings page
        if (e5.Plugins.config?.disableCssTransitionOnResize) {
            let t: any = null;
            window.addEventListener("resize", () => {
                document.body.classList.add("e5-disable-transition");
                clearTimeout(t);
                t = setTimeout(() => {
                    document.body.classList.remove("e5-disable-transition");
                });
            });
        }

        new AjaxClick();

        if (e5.Plugins.config?.isDebugging
            && !e5.Plugins.config?.isAdmin
            && e5.Plugins.config?.editPostInfo) {
            e5.Debug.add({
                uid: "e5-edit-post",
                icon: "fal fa-pen",
                tooltip: "Edit Inline",
                toggle: true,
                localStorage: true,
                onInit: (item) => {
                    let edit: PostEdit = null;
                    const toggle = () => {
                        if (item.active) {
                            edit = new PostEdit();
                        } else if (edit) {
                            edit.dispose();
                            edit = null;
                        }
                    };
                    toggle();

                    item.onToggle.add(toggle);
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", (e) => {
    new Frontend();
});